export const EACH_PERIOD_ENDS_TYPE_VALUES = {
  THE_SAME_DAY: 'THE_SAME_DAY',
  LAST_DAY: 'LAST_DAY'
}

export const EACH_PERIOD_ENDS_TYPE_OPTIONS = [
  {
    label: 'The same day each period',
    value: EACH_PERIOD_ENDS_TYPE_VALUES.THE_SAME_DAY
  },
  {
    label: 'Last day of each period',
    value: EACH_PERIOD_ENDS_TYPE_VALUES.LAST_DAY
  }
]

export const REPEAT_VALUES = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY'
}

export const REPEAT_OPTIONS = [
  { label: 'Week(s)', value: REPEAT_VALUES.WEEKLY },
  { label: 'Month(s)', value: REPEAT_VALUES.MONTHLY }
]

export const CAPTURE_TYPE_VALUES = {
  DAYS: 'DAYS',
  MONTHS: 'MONTHS'
}

export const CAPTURE_TYPE_OPTIONS = [
  { label: 'Day(s)', value: CAPTURE_TYPE_VALUES.DAYS },
  { label: 'Month(s)', value: CAPTURE_TYPE_VALUES.MONTHS }
]

export const KPI_RESULT_TYPE_VALUES = {
  SCALE: 'SCALE',
  VALUE: 'VALUE'
}

export const KPI_RESULT_TARGET_TYPE_VALUES = {
  GREATER: 'GREATER',
  BETWEEN: 'BETWEEN',
  LESS: 'LESS'
}

export const KPI_RESULT_TARGET_TYPE_OPTIONS = [
  { label: 'Greater or equal to', value: KPI_RESULT_TARGET_TYPE_VALUES.GREATER },
  { label: 'Between', value: KPI_RESULT_TARGET_TYPE_VALUES.BETWEEN },
  { label: 'Less or equal to', value: KPI_RESULT_TARGET_TYPE_VALUES.LESS }
]

export const RECURRENCE_ENDS_VALUES = {
  NEVER: 'NEVER',
  ON: 'ON'
}

export const RECURRENCE_ENDS_OPTIONS = [
  { label: 'Never', value: RECURRENCE_ENDS_VALUES.NEVER },
  { label: 'On', value: RECURRENCE_ENDS_VALUES.ON }
]

export const INPUT_METHOD_VALUES = {
  USER_INPUT: 'USER_INPUT',
  INTEGRATION: 'INTEGRATION'
}
